import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';
import { NgControl } from '@angular/forms';
import { InputErrorTypes } from 'app/modules/core/constants/core.constants';
import { BehaviorSubject } from 'rxjs';

@Directive({
  selector: '[appInputControl]',
  standalone: true
})
export class InputControlDirective {
  private ctrl = inject(NgControl);
  public element = inject(ElementRef);

  @Input() inputControlRegex: RegExp | string = ''; // regular expression to match against // if it does not match will stop the [paste / input]
  @Input() removeSpaces = false; // remove spaces
  @Input() trimSpaces = true; // just trim trailing and leading spaces
  oldValue$ = new BehaviorSubject(null);

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (!this.inputControlRegex) return;
    const regex =
      typeof this.inputControlRegex === 'string' ? new RegExp(this.inputControlRegex) : this.inputControlRegex;

    if (!this.checkKey(event, regex)) {
      this.ctrl.control?.setErrors({ ...this.ctrl.control?.errors, [InputErrorTypes.INVALID_CONTROL]: true });

      event.preventDefault();
    } else if (this.removeSpaces && event.code === 'Space') event.preventDefault();
  }

  @HostListener('focusout')
  focusLost(): void {
    if (this.inputControlRegex && this.ctrl.control?.errors?.[InputErrorTypes.INVALID_CONTROL]) {
      const regex = new RegExp(this.inputControlRegex);
      if (regex.test(this.ctrl.control.value)) {
        delete this.ctrl.control.errors[InputErrorTypes.INVALID_CONTROL];
        this.ctrl.control.updateValueAndValidity();
      }
    }

    if (!this.trimSpaces || this.inputControlRegex) return;
    const value = this.element.nativeElement.value.trim().replace(/\s\s+/g, ' ');
    if (this.ctrl.control) this.ctrl.control.setValue(value);
  }

  @HostListener('paste')
  onPrePaste() {
    this.oldValue$.next(this.element.nativeElement.value);
  }

  @HostListener('input', ['$event'])
  onPaste(event: Event): void {
    const inputEvent = event as InputEvent;
    if (inputEvent.inputType !== 'insertFromPaste') return;

    let value = this.trimSpaces ? this.element.nativeElement.value.trim() : this.element.nativeElement.value;

    if (this.removeSpaces) value = value.replace(/\s/g, '');
    const regex = new RegExp(this.inputControlRegex);

    if (this.ctrl.control) {
      if (regex.test(value)) {
        this.ctrl.control.setValue(value);
      } else {
        this.ctrl.control.setValue(this.oldValue$.value);
        this.ctrl.control?.setErrors({ ...this.ctrl.control?.errors, [InputErrorTypes.INVALID_CONTROL]: true });
      }
    }
  }

  private checkKey(ev: KeyboardEvent, regex: RegExp): boolean {
    if (ev.key && (ev.altKey || ev.ctrlKey || ev.metaKey || ev.key.length !== 1)) return true;

    const b = regex.test(ev.key);
    return b;
  }
}
